import React from 'react';

function EmployeeFamily({ employee, handleChange }) {
  return (
    <>
      <label>
        Spouse Name:
        <input
          name="spouseName"
          value={employee.spouseName || ''}
          onChange={handleChange}
        />
      </label>

      <label>
        Number of Children:
        <input
          type="number"
          name="childrenCount"
          value={employee.childrenCount || ''}
          onChange={handleChange}
        />
      </label>

      <label>
        Emergency Contact:
        <input
          name="emergencyContact"
          value={employee.emergencyContact || ''}
          onChange={handleChange}
        />
      </label>
    </>
  );
}

export default EmployeeFamily;
